import React from 'react';
import verified from '../../../images/verified.svg';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { navigate } from 'gatsby';
const BpVerified = () => {
  return (
    <div className="flex flex-col justify-start mx-auto space-y-10 mt-4 ">
      <img className="self-start block mx-auto" src={verified} alt="verified" />
      <p className="text-green-1200 text-xl font-semibold text-center">
        Your Profile is now Verified
      </p>
      <p className="">
        Congratulations,you are now one step closer to become{' '}
        <span className="font-semibold">Business Partner in LEMS.</span>
        <br /> To access your account Please click below button.
      </p>

      <button
        className="submitButton w-full items-center text-center"
        onClick={() => navigate('/?bplogin=true&redirect=/app/kyc')}
      >
        <span
          className="flex flex-row mx-auto items-center"
          style={{ width: 'max-content' }}
        >
          Click Here
          <KeyboardBackspaceIcon
            className="block cursor-pointer transform rotate-180 ml-2"
            color={'action'}
            style={{ fontSize: 36 }}
          />
        </span>
      </button>
    </div>
  );
};

export default BpVerified;
